import callApi, { CallApiResult } from '.';

export const sendRef = (ref: string, currentUrl: string): Promise<CallApiResult> => {
    return callApi(`/api/ref/${ref}`, { method: 'POST', data: currentUrl });
};
